import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/basemap/basemap.query.gql"
import type {
  BasemapQuery,
  BasemapQueryVariables,
} from "@/v2-backoffice-client/basemap/__types__/basemap.query"

type Options = QueryHookOptions<BasemapQuery, BasemapQueryVariables>

export function useBasemapQuery(options?: Options) {
  return useQuery<BasemapQuery, BasemapQueryVariables>(query, options)
}
